// See docs/next-url-collapse-observability.md for event schema, jdid hashing rationale, and queries.
import { createHmac } from 'crypto'

import { classifyRedirectUrl } from './redirect-url'

export type CollapseStep = 'cpf' | 'phone-step' | 'login-google'

interface NextUrlCollapseInput {
  step: CollapseStep
  raw: string | null | undefined
  jdid: string | null
}

const JDID_HASH_SALT = process.env.JDID_LOG_HASH_SALT ?? 'web-auth-next-url-collapse-v1'

function hashJdid(jdid: string | null): string | null {
  if (!jdid) return null
  return createHmac('sha256', JDID_HASH_SALT).update(jdid).digest('base64').slice(0, 22)
}

export function logNextUrlCollapse({ step, raw, jdid }: NextUrlCollapseInput): void {
  const { reason } = classifyRedirectUrl(raw)
  if (reason === 'ok' || reason === 'empty') return

  let originalHost: string | undefined
  try {
    originalHost = raw ? new URL(raw).host : undefined
  } catch {
    originalHost = undefined
  }

  console.log(
    JSON.stringify({
      event: 'next_url_collapsed',
      step,
      reason,
      original_host: originalHost,
      jdid_hash: hashJdid(jdid),
    })
  )
}
